import { Dispatch, SetStateAction, createContext, use } from 'react';
import { type TabsVariant } from './base';

/**
 * this is used to pass down props from the root Tabs component to its children.
 */
type TabsContextType = {
  variant: TabsVariant;
  setVariant?: Dispatch<SetStateAction<TabsVariant>>;
};

export const TabsContext = createContext<TabsContextType>({
  variant: 'basic',
});

export const useTabsContext = () => {
  const context = use(TabsContext);

  if (context === undefined)
    throw new Error('useTabsContext must be used within TabsProvider');

  return context;
};
